import { mapValues } from "lodash";

import { isRecord, isStyleValue } from "../Editor/utils/typePredicates";
import { isResponsiveValue } from "./isResponsiveValue";

export type Breakpoint = "desktop" | "tablet" | "mobile";

export function flattenResponsiveStylesDeep(
  styles: Record<string, unknown>,
  device: Breakpoint,
): Record<string, unknown> {
  return mapValues(styles, styleValue => {
    if (isStyleValue(styleValue) && isResponsiveValue(styleValue.value)) {
      return {
        ...styleValue,
        value: styleValue.value[device],
      };
    }

    if (isRecord(styleValue)) {
      return flattenResponsiveStylesDeep(styleValue, device);
    }

    return styleValue;
  });
}
